// Availability.js
import axiosInstance from '@/lib/axios';
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  return {
    'Authorization': `${tokenType} ${token}`,
    'Content-Type': 'application/json',
  };
};

export async function participantsPOST(data) {
  try {
    const response = await axiosInstance.post('/users/event_participants', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}

export async function participantsGET() {
  try {
    const response = await axiosInstance.get('/users/event_participants');
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}
export async function participantsPATCH(user_id, data) {

  const response = await axiosInstance.patch(`/users/event_participants/events/${user_id}`, data);
  return response.status === 204 ? null : response.data;


}

export async function participantsDELETE(eventId) {
  try {
    const response = await axiosInstance.delete(`/users/event_participants/${eventId}`);
    return response.status === 204 ? null : response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data || 'Request failed');
    } else {
      throw new Error(error.message);
    }
  }
}




export async function eventGET() {

  const response = await axiosInstance.get('/users/events');
  return response.data;

}





export async function myEventsGET() {

  const response = await axiosInstance.get('/users/events/me');
  return response.data;

}




export async function eventPATCH(data) {

  const payload = {
    id: data.id,
    event_name: data.event_name,
    event_date: data.event_date,
    time_range: data.time_range,
    description: data.description,
    venue: data.venue,
    max_participants: data.max_participants,
    permission: data.permission,
    address: data.address,
  };

  const response = await axiosInstance.patch('/users/events', payload);

  return response.status === 204 ? null : response.data;

}





export async function eventDELETE(data) {
  try {
    const response = await axiosInstance.delete(`/users/events/${data.id}`, {
      data,
    });

    return response.status === 204 ? null : response.data;
  } catch (err) {
    const errorMessage = err.response?.data || err.message;
    throw new Error(errorMessage);
  }
}





